const MAINTENANCE_PATH = '/__maintenance/';

let maintenanceActive = false;

type MaintenanceMarker = {
  maintenance?: unknown;
  error?: {
    maintenance?: unknown;
    code?: unknown;
  };
};

export const isMaintenancePayload = (payload: unknown): boolean => {
  if (!payload || typeof payload !== 'object') return false;
  const marker = payload as MaintenanceMarker;
  return marker.maintenance === true
    || marker.error?.maintenance === true
    || marker.error?.code === 'maintenance_in_progress';
};

export const areMaintenanceWritesBlocked = (): boolean => maintenanceActive;

export const isWriteMethod = (method: string | undefined): boolean =>
  !['get', 'head', 'options'].includes((method || 'get').toLowerCase());

export const activateMaintenanceMode = (): void => {
  if (maintenanceActive) return;
  maintenanceActive = true;
  window.dispatchEvent(new CustomEvent('pf2e:maintenance'));
  if (!window.location.pathname.startsWith(MAINTENANCE_PATH)) {
    window.location.replace(MAINTENANCE_PATH);
  }
};

const requestMethod = (input: RequestInfo | URL, init?: RequestInit): string => {
  if (init?.method) return init.method;
  if (typeof Request !== 'undefined' && input instanceof Request) return input.method;
  return 'GET';
};

export const installMaintenanceFetchGuard = (): void => {
  if (typeof window === 'undefined' || typeof window.fetch !== 'function') return;
  const nativeFetch = window.fetch.bind(window);
  window.fetch = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    if (maintenanceActive && isWriteMethod(requestMethod(input, init))) {
      throw new DOMException('maintenance_in_progress', 'InvalidStateError');
    }
    const response = await nativeFetch(input, init);
    if (response.status === 503 && response.headers.get('content-type')?.includes('application/json')) {
      try {
        const payload = await response.clone().json();
        if (isMaintenancePayload(payload)) activateMaintenanceMode();
      } catch {
        // A non-JSON 503 is an ordinary upstream failure, not a maintenance marker.
      }
    }
    return response;
  };
};
